export class OptionItem<T> {

  public label: string;

  public value: T;

}
